import React, { useEffect } from "react";
import { Form } from "react-final-form";
import MakeAsyncFunction from "react-redux-promise-listener";
import { promiseListener } from "../../../helpers/store";
import { Button } from "@material-ui/core";
import ColorsForm from "./ColorsForm";
import Box from "@material-ui/core/Box";
import { useDispatch } from "react-redux";
import { appActions } from "../../../actions/app.actions";
import { ADD_PRODUCT_COLOR_ERROR, ADD_PRODUCT_COLOR_REQUEST, ADD_PRODUCT_COLOR_RESPONSE } from "../../../actions/productColor.actions";

export default function ClientsNew() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(appActions.setNextPage("/renov/colors"));
  }, [dispatch]);
  return (
    <div>
      <MakeAsyncFunction
        listener={promiseListener}
        start={ADD_PRODUCT_COLOR_REQUEST}
        resolve={ADD_PRODUCT_COLOR_RESPONSE}
        reject={ADD_PRODUCT_COLOR_ERROR}
      >
        {(onSubmit) => (
          <Form
            mutators={{
              setValue: ([field, value], state, { changeValue }) => {
                changeValue(state, field, () => value);
              },
            }}
            onSubmit={(form) => {
              if (typeof form.ral === 'undefined') {
                form.ral = null;
              } else {
                form.ral = parseInt(form.ral);
              }

              form.products = [];

              return onSubmit(form);
            }}
            render={({ handleSubmit, submitting, values, form, valid }) => (
              <form onSubmit={handleSubmit}>
                <ColorsForm setValue={form.mutators.setValue} />

                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                  >
                    Ajouter
                  </Button>
                </Box>
              </form>
            )}
          />
        )}
      </MakeAsyncFunction>
    </div>
  );
}
